import React, { useState, useEffect } from 'react';
import './App.css';
import Portfolio from './components/Portfolio.tsx';
import KiosksPage from './components/KiosksPage.tsx';
import ExperientialPage from './components/ExperientialPage.tsx';
import GutenbergPage from './components/GutenbergPage.tsx';
import AboutPage from './components/AboutPage.tsx';
import MaintenanceSeoPage from './components/MaintenanceSeoPage.tsx';
import NotFoundPage from './components/NotFoundPage.tsx';

const getPage = () => {
  const hash = window.location.hash;
  const path = window.location.pathname.replace(/\/$/, '') || '/';

  // Support both hash (#/kiosks) and path (/kiosks) routing
  if (hash === '#/kiosks' || path === '/kiosks') {
    return 'kiosks';
  }
  if (hash === '#/experiential' || path === '/experiential') {
    return 'experiential';
  }
  if (hash === '#/gutenberg' || path === '/gutenberg') {
    return 'gutenberg';
  }
  if (hash === '#/about' || path === '/about') {
    return 'about';
  }
  if (hash === '#/maintenance-and-seo' || path === '/maintenance-and-seo') {
    return 'maintenance-and-seo';
  }
  // Anything else is a real 404: the host serves index.html for every
  // path, so without this unknown URLs would render the homepage (soft 404).
  return path === '/' ? 'home' : 'not-found';
};

/**
 * Simple hash-based routing to support dedicated landing pages
 * without requiring react-router or server-side configuration.
 * Routes: / (main portfolio), /kiosks (interactive installations page), /experiential (brand experiences page), /gutenberg (block editor development page), /about (about page), /maintenance-and-seo (maintenance and SEO plans)
 *
 * The first render must already be the requested page: rendering the homepage
 * first would replace the prerendered HTML with it and start loading its images.
 */
function App() {
  const [currentPage, setCurrentPage] = useState(getPage);

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPage(getPage());
    };

    window.addEventListener('hashchange', handleHashChange);
    window.addEventListener('popstate', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
      window.removeEventListener('popstate', handleHashChange);
    };
  }, []);

  // Scroll to anchor or top when page changes
  useEffect(() => {
    const hash = window.location.hash;
    // If hash is an anchor (not a route like #/kiosks), scroll to it
    if (hash && !hash.startsWith('#/')) {
      const el = document.getElementById(hash.substring(1));
      if (el) {
        // Small delay to let the page render before scrolling
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [currentPage]);

  if (currentPage === 'kiosks') {
    return <KiosksPage />;
  }

  if (currentPage === 'experiential') {
    return <ExperientialPage />;
  }

  if (currentPage === 'gutenberg') {
    return <GutenbergPage />;
  }

  if (currentPage === 'about') {
    return <AboutPage />;
  }

  if (currentPage === 'maintenance-and-seo') {
    return <MaintenanceSeoPage />;
  }

  if (currentPage === 'not-found') {
    return <NotFoundPage />;
  }

  return <Portfolio />;
}

export default App;